import PropTypes from 'prop-types';
import React from 'react';
import AssetList from '../AssetList/AssetList';

import './Section.css';

class Section extends React.Component {
  static propTypes = {
    assets: PropTypes.array,
    section: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    onClickAttachments: PropTypes.func.isRequired
  };

  render() {
    return (
      <div className="section">
        <h2>{this.props.section.attributes.name}</h2>
        <AssetList
          assets={this.props.assets}
          onClick={value => this.props.onClick(value)}
          onClickAttachments={value => this.props.onClickAttachments(value)}
        />
      </div>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/Section.js